import { getCurrentCulture, getCurrentLanguage, isCurrentCultureRightToLeft } from 'owa-localize';

export default function useSuiteHeaderLanguageProps(): {
    culture: string;
    language: string;
    isRTL: boolean;
} {
    return {
        culture: getCurrentCulture(),
        language: getCurrentLanguage(),
        isRTL: isCurrentCultureRightToLeft(),
    };
}
